/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';

import { WorkCreateTenantApiKeyDto } from '../models/work-create-tenant-api-key-dto';
import { WorkCreateTenantApiKeyResponseDto } from '../models/work-create-tenant-api-key-response-dto';
import { WorkTenantApiKey } from '../models/work-tenant-api-key';
import { WorkUpdateTenantApiKeyDto } from '../models/work-update-tenant-api-key-dto';

@Injectable({ providedIn: 'root' })
export class WorkTenantsApiKeysV2Service extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `tenantApiKeysV2ControllerFindAll()` */
  static readonly TenantApiKeysV2ControllerFindAllPath = '/v2/tenants/api-keys';

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantApiKeysV2ControllerFindAll()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerFindAll$Response(
    params?: {
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<Array<WorkTenantApiKey>>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsApiKeysV2Service.TenantApiKeysV2ControllerFindAllPath, 'get');
    if (params) {
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<WorkTenantApiKey>>;
      })
    );
  }

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantApiKeysV2ControllerFindAll$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerFindAll(
    params?: {
    },
    context?: HttpContext
  ): Observable<Array<WorkTenantApiKey>> {
    return this.tenantApiKeysV2ControllerFindAll$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<WorkTenantApiKey>>): Array<WorkTenantApiKey> => r.body)
    );
  }

  /** Path part for operation `tenantApiKeysV2ControllerCreate()` */
  static readonly TenantApiKeysV2ControllerCreatePath = '/v2/tenants/api-keys';

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantApiKeysV2ControllerCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantApiKeysV2ControllerCreate$Response(
    params: {
      body: WorkCreateTenantApiKeyDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkCreateTenantApiKeyResponseDto>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsApiKeysV2Service.TenantApiKeysV2ControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkCreateTenantApiKeyResponseDto>;
      })
    );
  }

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantApiKeysV2ControllerCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantApiKeysV2ControllerCreate(
    params: {
      body: WorkCreateTenantApiKeyDto
    },
    context?: HttpContext
  ): Observable<WorkCreateTenantApiKeyResponseDto> {
    return this.tenantApiKeysV2ControllerCreate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkCreateTenantApiKeyResponseDto>): WorkCreateTenantApiKeyResponseDto => r.body)
    );
  }

  /** Path part for operation `tenantApiKeysV2ControllerFindOne()` */
  static readonly TenantApiKeysV2ControllerFindOnePath = '/v2/tenants/api-keys/{id}';

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantApiKeysV2ControllerFindOne()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerFindOne$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantApiKey>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsApiKeysV2Service.TenantApiKeysV2ControllerFindOnePath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantApiKey>;
      })
    );
  }

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantApiKeysV2ControllerFindOne$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerFindOne(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTenantApiKey> {
    return this.tenantApiKeysV2ControllerFindOne$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantApiKey>): WorkTenantApiKey => r.body)
    );
  }

  /** Path part for operation `tenantApiKeysV2ControllerUpdate()` */
  static readonly TenantApiKeysV2ControllerUpdatePath = '/v2/tenants/api-keys/{id}';

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantApiKeysV2ControllerUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantApiKeysV2ControllerUpdate$Response(
    params: {
      id: number;
      body: WorkUpdateTenantApiKeyDto
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantApiKey>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsApiKeysV2Service.TenantApiKeysV2ControllerUpdatePath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantApiKey>;
      })
    );
  }

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantApiKeysV2ControllerUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  tenantApiKeysV2ControllerUpdate(
    params: {
      id: number;
      body: WorkUpdateTenantApiKeyDto
    },
    context?: HttpContext
  ): Observable<WorkTenantApiKey> {
    return this.tenantApiKeysV2ControllerUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantApiKey>): WorkTenantApiKey => r.body)
    );
  }

  /** Path part for operation `tenantApiKeysV2ControllerRemove()` */
  static readonly TenantApiKeysV2ControllerRemovePath = '/v2/tenants/api-keys/{id}';

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantApiKeysV2ControllerRemove()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerRemove$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<void>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsApiKeysV2Service.TenantApiKeysV2ControllerRemovePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'text', accept: '*/*', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantApiKeysV2ControllerRemove$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerRemove(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<void> {
    return this.tenantApiKeysV2ControllerRemove$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `tenantApiKeysV2ControllerDeactivate()` */
  static readonly TenantApiKeysV2ControllerDeactivatePath = '/v2/tenants/api-keys/{id}/deactivate';

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `tenantApiKeysV2ControllerDeactivate()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerDeactivate$Response(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<StrictHttpResponse<WorkTenantApiKey>> {
    const rb = new RequestBuilder(this.rootUrl, WorkTenantsApiKeysV2Service.TenantApiKeysV2ControllerDeactivatePath, 'post');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(
      rb.build({ responseType: 'json', accept: 'application/json', context })
    ).pipe(
      filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<WorkTenantApiKey>;
      })
    );
  }

  /**
   * Required permissions: tenants:admin
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `tenantApiKeysV2ControllerDeactivate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  tenantApiKeysV2ControllerDeactivate(
    params: {
      id: number;
    },
    context?: HttpContext
  ): Observable<WorkTenantApiKey> {
    return this.tenantApiKeysV2ControllerDeactivate$Response(params, context).pipe(
      map((r: StrictHttpResponse<WorkTenantApiKey>): WorkTenantApiKey => r.body)
    );
  }

}
